import { Checkbox, Switch } from '@progress/kendo-react-inputs';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsTooltipsElement() {
    const settings = useAppSelector((x) => x.settings.tooltipSettings);
    const dispatch = useAppDispatch();
    const context = useSearchContext();

    const changeItem = (name: keyof (typeof settings)['items'], value: boolean) => {
        dispatch(
            setSetting('tooltipSettings', {
                ...settings,
                items: {
                    ...settings.items,
                    [name]: value
                }
            })
        );
    };
    return (
        <div className="px-3 py-2">
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <MarkerText highlight={context.term}>Require CTRL to be pressed to open following tooltips</MarkerText>
                </div>
                <Switch
                    checked={settings.requireCtrlKey}
                    onChange={(e) =>
                        dispatch(
                            setSetting('tooltipSettings', {
                                ...settings,
                                requireCtrlKey: e.value
                            })
                        )
                    }
                />
            </div>
            <div className="pt-2 d-flex flex-column gap-1">
                <Checkbox checked={settings.items.planes} onChange={(e) => changeItem('planes', e.value)} label="Planes" />
                <Checkbox checked={settings.items.weather} onChange={(e) => changeItem('weather', e.value)} label="Weather" />
                <Checkbox checked={settings.items.navData} onChange={(e) => changeItem('navData', e.value)} label="Nav data" />
                <Checkbox checked={settings.items.other} onChange={(e) => changeItem('other', e.value)} label="Other" />
            </div>
        </div>
    );
}
